export default [
  {
    path: '/main/arena/equipment-version',
    meta: {
      tag: 'list_arena_equipment_version',
      name: 'Versão de equipamento (Arena)',
      breadcrumb: 'Versão de equipamento (Arena)'
    },
    component: () => import(/* webpackChunkName: "arena-equipment-version-list" */ '@/views/main/settings/arena/equipment-version/Index.vue'),
    children: [
      {
        path: '',
        name: 'listarenaequipmentversion',
        meta: {
          tag: 'list_arena_equipment_version',
          menu: 'settings',
          name: 'Versão de equipamento (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-equipment-version-list" */ '@/views/main/settings/arena/equipment-version/List.vue'),
      },
      {
        path: '/main/arena/equipment-version/add',
        name: 'addarenaequipmentversion',
        meta: {
          tag: 'add_arena_equipment_version',
          menu: 'settings',
          name: 'Adicionar | Versão de equipamento (Arena)',
          breadcrumb: 'Adicionar Versão de equipamento (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-equipment-version-add" */ '@/views/main/settings/arena/equipment-version/Add.vue')
      },
      {
        path: '/main/arena/equipment-version/:id',
        name: 'editarenaequipmentversion',
        meta: {
          tag: 'edit_arena_equipment_version',
          menu: 'settings',
          name: 'Editar | Versão de equipamento (Arena)',
          breadcrumb: 'Editar Versão de equipamento (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-equipment-version-edit" */ '@/views/main/settings/arena/equipment-version/Edit.vue')
      }
    ]
  }
]
